import React, { useEffect, useState } from 'react';

// ProgressBar component to show progress
const ProgressBar = ({ taskId }) => {
  const [progress, setProgress] = useState({ percentage: 0, currentItem: '' });
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    const socket = new WebSocket(`ws://localhost:8000/progress/${taskId}`); // Connect to WebSocket

    socket.onopen = () => {
      console.log("WebSocket connection established.");
      setIsLoading(false); // Start showing the progress once WebSocket is connected
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setProgress(data); // Directly use the data as it is already structured
    };

    socket.onclose = () => {
      console.log("WebSocket connection closed.");
    };

    // Cleanup WebSocket on component unmount
    return () => {
      socket.close();
    };
  }, [taskId]);

  return (
    <div>
      <h3>{isLoading ? 'Starting task...' : `Task Progress: ${progress.currentItem}`}</h3>
      <p>{isLoading ? '0/0' : `${progress.itemNumber} of ${progress.itemMax}`}</p>

      <div
        style={{
          width: '100%',
          height: '25px',
          backgroundColor: '#e0e0e0',
          borderRadius: '5px',
        }}
      >
        <div
          style={{
            width: `${progress.percentage}%`,
            height: '100%',
            backgroundColor: '#4caf50',
            borderRadius: '5px',
          }}
        ></div>
      </div>
      <p>{progress.percentage}%</p>
    </div>
  );
};

// Main component to handle progress bar and task initiation
const TestProgress = () => {
  const [taskId, setTaskId] = useState(`task-${Date.now()}`);

  return (
    <div>
      <h2>Testing Progress Bar</h2>
      <ProgressBar taskId={taskId} />
      <button onClick={() => setTaskId(`task-${Date.now()}`)}>Start New Task</button>
    </div>
  );
};

export default TestProgress;
